import React, { PropTypes } from 'react';
import { getButtonUI } from '../../businessLogic/components';
import ReactTooltip from 'react-tooltip';
import { prettyAlert } from '../Common/Dialog';

export default class ActionBar extends React.Component {

	getDeleteButton() {
		return this.props.showDelete 
			? (
			<div className="col-md-1">			
				<button 
					type="button" 
					className="btn btn-danger btn-block"
					disabled={this.props.upload.status === "IN_PROGRESS"}
					onClick={() => this.props.onDelete()}						
				>
					<i className="fa fa-trash fa-2x" data-tip="Deletar Documento" />
				</button>
				<ReactTooltip />
			</div>
			) : null;
	}

	validatePoints(points) {
		for (const point of points) {
			if (!point.lat || !point.lng) return false;
		}

		return true;
	}

	validateDuplicatedPictureFiles(points) {
		var duplicatedFilenames = [];

		var imageFileCache = {};

		for (const pnt of points) {
			pnt.img.map((i) => {
				if ( imageFileCache.hasOwnProperty(i.filehash) ) duplicatedFilenames.push(i.src.name);
				else imageFileCache[i.filehash] = i;
			});
			pnt.savedImg.map((i) => {
				if ( imageFileCache.hasOwnProperty(i.file_hash) ) duplicatedFilenames.push(i.filename);
				else imageFileCache[i.file_hash] = i;
			});
		}
		
		console.warn("Duplicated image files found: " + duplicatedFilenames);
		
		return duplicatedFilenames;
	}

	render () {				
		const { onSave, document, upload, selected } = this.props;		
		const { files, points, ...finalDoc } = document;

		return (
			
			<div className="row">
				
				<div className="col-md-3" style={{paddingRight: "0px"}}>			
					<button 
						type="button" 
						className="btn btn-primary btn-lg btn-block"
						disabled={(upload.status === "IN_PROGRESS" ) || !(this.props.salvarEnabled)}
						onClick={() => {
							if ( document.title === "" ) {
								prettyAlert("Título é obrigatório!");
								return;
							}
							//@TODO: deixar sem documento length ==0
							if ( files === null ) {
								prettyAlert("Selecione ao menos um arquivo!");
								return;
							}
							if ( document.groups.length === 0 && document.hasOwner === 1 ) {
								prettyAlert("Selecione pelo menos um grupo.");
								return;
							}
							
							const duplicatedImgFilenames = this.validateDuplicatedPictureFiles(points);
							if (duplicatedImgFilenames.length > 0) {
								const message1 = "As imagens a seguir estão duplicadas neste documento, ";
								const message2 = "por favor, remova e tente novamente:";
								prettyAlert("Imagens duplicadas!", `${message1}${message2} \n\n ${duplicatedImgFilenames.join('\n')}`);
								return;
							}

							if (!this.validatePoints(points)) {
								prettyAlert("Preencha todos os campos de Latitude e Longitude.");
								return;
							}

							onSave(finalDoc, files, points, selected);
						}}>
						Salvar
					</button>
				</div>
				<div className="col-md-8">
					<div style={{padding: "9px"}}>{getButtonUI(upload.status, upload.message, upload.progress)}</div>
				</div>
				{this.getDeleteButton()}		
			</div>
		);
	}
}

ActionBar.propTypes = {
	upload: PropTypes.object.isRequired,
	onSave: PropTypes.func.isRequired,
	onDelete: PropTypes.func.isRequired,
	showDelete: PropTypes.bool.isRequired,
	selected: PropTypes.number,
	salvarEnabled: PropTypes.bool.isRequired,
	document: PropTypes.object.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Documents/ActionBar.js